<!--视频提取-->
<template>
  <div class="extraction-container">
    <div class="ex-title" :style="{ color: theme.worksColor2 }">视频提取</div>

    <div class="shuru-box">
      <img class="img1" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.4_Words.png" alt="">
      <div class="im-sr-box">
        <div class="flex ac jb">
          <el-input v-model="link" placeholder="请将短视频地址粘贴到这里"></el-input>
          <div class="jx-btn cr" @click="handleJx">开始解析</div>
        </div>
        <!--        <div class="tip-box" v-if="freeNum*1>0">每日免费{{freeNum}}条</div>-->
        <div class="tip-box">50积分/每条</div>
      </div>
      <img class="img2" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.4_Logo.png" alt="">
    </div>

    <div class="js-info-box">
      <div class="js-info-header flex ac jb">
        <div class="flex ac cr">
          <div class="flex ac">
            <p class="mr30" :class="titleId==1?'title-active':''" @click="choosedTitle(1)">全部视频</p>
            <p class="mr30" :class="titleId==2?'title-active':''" @click="choosedTitle(2)">处理中</p>
            <p :class="titleId==3?'title-active':''" @click="choosedTitle(3)">已失败</p>
          </div>

          <div class="small-tip">*去水印后请尽快下载，下载内容是会过期的!</div>


        </div>
      </div>

      <div class="all-table-info">
        <div class="tab-box-head flex ac">
          <div class="dv1">编号</div>
          <div class="dv2">解析状态</div>
          <div class="dv3">视频信息</div>
          <div class="dv4">操作</div>
        </div>

        <div class="tab-box-info">
          <div class="every-table flex ac" v-for="(item,index) in analyseList" :key="index">
            <div class="info-dv1">
              {{index+1}}
            </div>
            <div class="info-dv2 flex ac">
              <img v-if="item.status==3"
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.5_Icon_Succeed.png" alt="">
              <img v-else-if="item.status==4"
                   src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.5_Icon_Wrong.png" alt="">
              <span :class="item.status==3?'success-word':item.status==4 ? 'fail-word' :'' ">{{item.status_name}}</span>
            </div>
            <div class="info-dv3 flex ac">
              <img v-if="item.cover" :src="item.cover" alt="">
              <div style="width: 100%">
                <p class="te" style="width: 90%" v-if="item.desc">{{item.desc}}</p>
                <p v-if="item.size>0">{{item.size}}</p>
              </div>
            </div>
            <div class="info-dv4 flex ac cr" v-if="item.status==3" @click="handleDown(item)">
              <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/15.5_Icon_Download.png" alt="">
              <p>下载视频</p>
            </div>
            <div class="info-dv4 flex ac cr" @click="handleSave(item)" v-if="item.status==3">
              <i class="el-icon-folder-add mr05"></i>
              <p>保存到素材</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {getVideoAnalyse, postMaterial, postVideoAnalyse, videoAnalyseFree} from '../api/user'

  export default {
    name: '',
    data() {
      return {
        link: '',
        titleId: 1,
        analyseList: [],
        freeNum: 0,
        selectObj: {
          limit: 999,
          page: 1,
          status: ''
        }
      }
    },
    computed: {
      myHeaders() {
        return {'x-token': window.localStorage.getItem('xcToken') || ''}
      },
      theme() {
        return this.$store.getters.getTheme;
      }
    },
    created() {
      this.getVideoAnalyseInfo()
      this.getVideoAnalyseFree()
    },
    methods: {

      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      },

      getVideoAnalyseInfo() {
        getVideoAnalyse({...this.selectObj}).then(res => {
          this.analyseList = res.data.list
        })
      },
      getVideoAnalyseFree() {
        videoAnalyseFree().then(res => {
          this.freeNum = res.data.num
        })
      },

      choosedTitle(val) {
        this.titleId = val
        if (val == 1) {
          this.selectObj.status = ''
        }
        if (val == 2) {
          this.selectObj.status = 1
        }
        if (val == 3) {
          this.selectObj.status = 4
        }
        this.getVideoAnalyseInfo()
      },

      handleJx() {
        this.loading = this.$loading({
          lock: true,
          text: '解析中,请等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.6)'
        });
        postVideoAnalyse({link: this.link}).then(res => {
          this.$message.success(res.msg)
          this.getVideoAnalyseInfo()
          this.getVideoAnalyseFree()
          this.$store.dispatch('updatePoints')
          this.loading.close();
        }).catch(error => {
          this.$message.error(error.msg)
          this.loading.close();
        })
      },
      handleDown(item) {
        window.open(item.url, '_blank', 'noopener,noreferrer');

        // const that = this
        // var xhr = new XMLHttpRequest()
        // xhr.open('GET', item.url, true)
        // xhr.responseType = 'blob' // 返回类型blob
        // // 监听进度
        // xhr.onprogress = function (e) {
        //   if (e.lengthComputable) {
        //     var percentComplete = 0
        //     var percentComplete = e.loaded / e.total * 100;
        //   }
        // }
        // xhr.onload = function () {
        //   if (xhr.readyState === 4 && xhr.status === 200) {
        //     console.log('开始下载')
        //     const blob = this.response
        //     // 转换一个blob链接
        //     const u = window.URL.createObjectURL(new Blob([blob]))
        //     const a = document.createElement('a')
        //     var str = ''
        //     str = item.name + '.mp4'
        //     a.download = str
        //     a.href = u
        //     document.body.appendChild(a)
        //     a.click()
        //     console.log('结束')
        //     that.$message.success('下载成功！')
        //     window.URL.revokeObjectURL(u)
        //   } else {
        //     console.log('失败了')
        //     that.$message.error('下载失败！')
        //   }
        // }
        // xhr.onerror = function () {
        //   that.$message.error('下载失败！')
        // }
        // xhr.send()
      },
      handleSave(item) {
        this.$confirm('此操作将保存该视频到素材库（处理完才会在素材库显示） , 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          postMaterial({type: 'video', source: 'analyse', name: item.desc.slice(0, 15), rid: item.id}).then(res => {
            if (res.code == 0) {
              this.$message.success('保存成功，系统处理完会在素材库中显示')
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消保存'
          })
        })
      },
    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {
    },
  }
</script>

<style lang="scss" scoped>
  .extraction-container {

    .ex-title {
      font-weight: 500;
      font-size: 24px;
      color: #FFFFFF;
      margin: 22px 40px;
    }

    .shuru-box {
      width: 1640px;
      height: 340px;
      padding-top: 42px;
      background: #191B2F;
      border-radius: 12px;
      border: 2px solid rgba(255, 255, 255, 0.15);
      margin: 0 auto;

      .img1 {
        width: 479px;
        height: 85px;
        display: block;
        margin: 0 auto;
      }

      .img2 {
        width: 535px;
        height: 40px;
        display: block;
        margin: 0 auto;
      }

      .im-sr-box {
        width: 880px;
        height: 64px;
        background: rgba(255, 255, 255, 0.02);
        border-radius: 8px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        margin: 32px auto;
        padding: 5px 5px 0 5px;

        position: relative;

        .tip-box {
          position: absolute;
          top: -15px;
          left: 16px;
          width: 83px;
          height: 22px;
          background: #0DE1F6;
          border-radius: 5px;

          font-weight: 400;
          font-size: 12px;
          color: #191B2F;
          line-height: 22px;
          text-align: center;
          cursor: pointer;
        }

        .jx-btn {
          width: 160px;
          height: 48px;
          background: linear-gradient(312deg, #6C14FF 0%, #01FBF5 100%);
          border-radius: 8px;

          font-weight: 600;
          font-size: 18px;
          color: #FFFFFF;
          line-height: 48px;
          text-align: center;
        }
      }
    }

    .js-info-box {
      width: 1640px;
      height: 472px;
      background: #191B2F;
      border-radius: 12px;
      margin: 16px auto 0;
    }

    .js-info-header {
      height: 80px;
      width: 100%;
      border-bottom: 1px solid #393C4E;
      padding: 0 40px;

      font-weight: 500;
      font-size: 18px;
      color: #FAFAFAAA;

      .small-tip {
        margin-left: 20px;
        font-weight: 400;
        font-size: 12px;
        color: #C1904C;
      }

      .title-active {
        font-weight: 500;
        font-size: 18px;
        color: #FAFAFA;
      }
    }

    .all-table-info::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }

    .all-table-info {
      height: calc(472px - 105px);
      overflow-y: scroll;
      overflow-x: hidden;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* Internet Explorer 10+ */
    }

    .tab-box-head {
      width: 1560px;
      height: 40px;
      background: rgba(117, 123, 195, 0.2);
      border-radius: 2px;
      margin: 24px auto 0;
      text-align: left;

      .dv1 {
        padding-left: 20px;
        width: 150px;
      }

      .dv2 {
        padding-left: 20px;
        width: 150px;
      }

      .dv3 {
        padding-left: 20px;
        width: 1100px;
      }

      .dv4 {
        padding-left: 20px;
        width: 160px;
      }
    }

    .tab-box-info {

      width: 1560px;
      /*height: 80px;*/
      background: rgba(84, 90, 154, 0.1);
      border-radius: 2px;
      margin: 0 auto;

      .every-table {
        width: 100%;
        margin-bottom: 4px;
        background: rgba(84, 90, 154, 0.1);
        border-radius: 2px;
      }

      .info-dv1 {
        padding-left: 20px;
        width: 150px;
      }

      .info-dv2 {
        width: 150px;
        padding-left: 20px;
        font-weight: 400;
        font-size: 14px;

        img {
          width: 20px;
          height: 20px;
        }

        .success-word {
          color: #32B052;
        }

        .fail-word {
          color: #D9A030;
        }
      }

      .info-dv3 {
        width: 1050px;

        p {
          padding: 0;
          margin: 0;
        }

        padding: 16px 20px;

        img {
          width: 48px;
          height: 48px;
          border-radius: 6px;
          margin-right: 16px;
        }

      }

      .info-dv4 {
        width: 100px;
        font-weight: 500;
        font-size: 14px;
        color: #04F6F6;

        img {
          width: 20px;
          height: 20px;
          display: block;
          margin-right: 4px;
        }
      }
    }
  }
</style>
<style lang="scss">
  .im-sr-box {
    .el-input__inner {
      background: none;
      border: none;
      color: #ffffff;
    }

    .el-input__inner:focus {
      border-color: #dcdfe6 !important; /* 设置为输入框的默认边框颜色 */
      outline: none; /* 去掉轮廓线 */
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/extraction.vue